export enum EPageModule {
  OVERALL_INTRO = 'overall_intro',
  FEED_INTRO = 'feed_intro',
  SEARCH_INTRO = 'search_intro',
  INTERACT_INTRO = 'interact_intro',
  LEMO_WELCOME = 'lemo_welcome',
}
